import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Agencies } from 'app/models/agencies';
import { Observable, Subject, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class MobileAppsService {
  base_path = 'https://app.titv-store-api.com/';
  
  constructor(private http: HttpClient) { }
  
  private refreshData = new Subject<void>();
  
  get refreshNeeded() {
    return this.refreshData;
  }

  private getToken(): string {
    try {
      const authUser = sessionStorage.getItem('auth-user');
      if (authUser) {
        const userObj = JSON.parse(authUser);
        return userObj.token || '';
      }
      return '';
    } catch {
      return '';
    }
  }

  private getHeaders(): HttpHeaders {
    const token = this.getToken();
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    if (token) {
      headers = headers.set('Authorization', 'Bearer ' + token);
    }
    return headers;
  }

  private getPublicHeaders(): HttpHeaders {
    return new HttpHeaders({ 'Content-Type': 'application/json' });
  }

  private handleError(error: HttpErrorResponse) {
    let errorMessage = 'Une erreur est survenue';
    
    if (error.status === 403) {
      errorMessage = `Accès interdit. Token: ${this.getToken() ? 'présent' : 'absent'}`;
    } else if (error.status === 401) {
      errorMessage = 'Non autorisé. Veuillez vous reconnecter.';
    } else if (error.status) {
      errorMessage = `Erreur ${error.status}: ${error.message}`;
    } else {
      errorMessage = `Erreur réseau: ${error.message || 'connexion impossible'}`;
    }
    
    console.error('Erreur MobileAppsService:', errorMessage, error);
    return throwError(() => new Error(errorMessage));
  }

  // ✅ Retourne une chaîne (message du backend)
  createApp(item: any): Observable<string> {
    return this.http.post(
      this.base_path + 'app/add', 
      JSON.stringify(item), 
      { headers: this.getHeaders(), responseType: 'text' }
    ).pipe(
      tap(() => this.refreshData.next()),
      catchError(this.handleError.bind(this))
    );
  }

  getApp(id: any): Observable<Agencies> {
    return this.http.get<Agencies>(
      this.base_path + 'app/' + id,
      { headers: this.getPublicHeaders() }
    ).pipe(catchError(this.handleError.bind(this)));
  }

  getListApp(): Observable<Agencies[]> {
    return this.http.get<Agencies[]>(
      this.base_path + 'app/all',
      { headers: this.getPublicHeaders() }
    ).pipe(catchError(this.handleError.bind(this)));
  }
 
  // ✅ Retourne une chaîne (message du backend)
  updateApp(id: any, item: any): Observable<string> {
    console.log('🔧 updateApp called with id:', id, 'payload:', item);
    return this.http.put(
      this.base_path + 'app/edit/' + id, 
      JSON.stringify(item), 
      { headers: this.getHeaders(), responseType: 'text' }
    ).pipe(
      tap(() => this.refreshData.next()),
      catchError(this.handleError.bind(this))
    );
  }

  deleteApp(id: any): Observable<any> {
    return this.http.delete<any>(
      this.base_path + 'app/delete/' + id, 
      { headers: this.getHeaders() }
    ).pipe(
      tap(() => this.refreshData.next()),
      catchError(this.handleError.bind(this))
    );
  }
}